//导入模块
import Vue from 'vue'
import VueRouter from 'vue-router'
import API from './modules/api'
import Common from './modules/common'
import Screenshots from './modules/screenshots'

//注册路由组件
Vue.use(VueRouter)
//编写路由规则
const routes = [...API, ...Common, ...Screenshots]
//创建路由
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      y: 0
    }
  }
})
//导出
export default router
